<template>
    <div
        class="md-snapshot-search template4"
        :style="{ paddingTop, marginBottom }"
    >
        <component
            :is="mdSearchBar"
            :searchBarOnly="true"
            :hideSearch="true"
            ref="search"
            :propsToData="dataToSearchBar"
            @conditionChange="conditionChange"
            v-show="showSearchBar"
        />
        <div class="market_snapshot_container">
            <module-box class="module_box" noPadding noMargin>
                <!-- Market Snapshot start  -->
                <market-report :title="snapshotMarketTitle" />
                <!-- Market Snapshot end  -->
            </module-box>
        </div>
    </div>
</template>

<script>
import MarketReport from './components/market-report/index';
import common from '../index';
import searchBarMixin from '../../md-search-bar-mixin';
export default {
    mixins: [common, searchBarMixin('template4')],
    components: {
        'market-report': MarketReport
    },
    computed: {
        cmpDefaultMoreBtnTitle() {
            return (
                this.defaultMoreBtnTitle ??
                this.$t(
                    'md-snapshot-search.requestMoreMarketInsights'
                ).toUpperCase()
            );
        },
        cmpDefaultListingTitle() {
            return this.$t('md-snapshot-search.recentListings').toUpperCase();
        }
    }
};
</script>
<style lang="scss">
.md-snapshot-search.template4{
    .market_snapshot_container {
        background: #fff;
    }
    /*
    .title_container {
        padding-top: 50px;
    }
    */

    @media (max-width: 600px) {
        .module_box {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            box-sizing: border-box;
            background: #fff;
        }
    }
}
</style>
